import WelcomeError from '../components/WelcomeError.vue'
import LandingPage from '../components/LandingPage.vue'
import Passworld from '../components/Passworld.vue'

import PresskitOne from '../components/press/PresskitOne'
import Backoffice from '../components/Backoffice'

import Spaceship from '../components/Spaceship.vue'
import MainHall from '../components/spaceship/MainHall.vue'
import Corridor from '../components/spaceship/Corridor.vue'
import TutoRespect from '../components/TutoRespect.vue'
import MapRoom from '../components/spaceship/MapRoom.vue'
import CorridorChill from '../components/spaceship/CorridorChill.vue'
import Chillroom from '../components/spaceship/Chillroom.vue'
import Plantroom from '../components/spaceship/Plantroom.vue'
import Dojo from '../components/spaceship/Dojo.vue'
import Library from '../components/spaceship/Library.vue'
import Crewroom from '../components/spaceship/Crewroom.vue'
import Toilets from '../components/spaceship/Toilets.vue'
import Cockpit from '../components/spaceship/Cockpit.vue'

export default [{
        path: '/',
        component: LandingPage
    }, {
        path: '/error',
        component: WelcomeError
    }, {
        path: '/passworld',
        component: Passworld
    }, {
        path: '/spaceship',
        component: Spaceship
    }, {
        path: '/main-hall',
        component: MainHall,
        name: 'main-hall'
    }, {
        path: "/corridor-dojo",
        component: Corridor
    }, {
        path: "/tuto-respect",
        component: TutoRespect
    }, {
        path: "/maproom",
        component: MapRoom
    }, {
        path: "/corridor-chill",
        component: CorridorChill
    }, {
        path: "/chillroom",
        component: Chillroom
    }, {
        path: "/plantroom",
        component: Plantroom
    }, {
        path: "/dojo",
        component: Dojo
    }, {
        path: "/library",
        component: Library
    }, {
        path: "/crewroom",
        component: Crewroom
    }, {
        path: "/toilets",
        component: Toilets
    }, {
        path: "/cockpit",
        component: Cockpit
    }, {
        path: "/next-release",
        component: Toilets
    },

    {
        path: '/presskit-one',
        component: PresskitOne
    },
    {
        path: '/backoffice',
        component: Backoffice
    },
    { path: "*", redirect: '/error'}
]